import axios from "axios";
import { MasterEmployeeReq } from "../schemas/workflow.shema";

export function putInsertOrUpdateWorkflowUser(body: MasterEmployeeReq) {
    return axios.put<{ message: string }>('/v1/insertorupdate/workflow', body, {
        headers: {
            Authorization: 'Bearer ' + localStorage.getItem('SSO_AUTH')
        }
    });
}